import { render, staticRenderFns } from "./PropostaContador.vue?vue&type=template&id=f3ca20b0&"
import script from "./PropostaContador.vue?vue&type=script&lang=ts&"
export * from "./PropostaContador.vue?vue&type=script&lang=ts&"
import style0 from "./PropostaContador.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
